// src/styles/theme.js

const theme = {
  colors: {
    primary: "#0070f3",
    background: "#f0f2f5",
    text: "#333333",
    white: "#ffffff",
    secondary: "#ff5722",
    gray: "#999999",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "32px",
    xl: "64px",
  },
  fonts: {
    body: "'Segoe UI', sans-serif",
    heading: "'Segoe UI Bold', sans-serif",
  },
};
export type AppTheme = typeof theme;
export default theme;
